module.exports = __webpack_public_path__ + "static/how_we_do_it_2x-d13fa784ac1c98e22522089408a9cdb3.png";